// src/utils/api.js
import axios from "axios";

const modeURL =
  process.env.NODE_ENV === "production"
    ? "https://server.pinkuppers.com.br"
    : "http://localhost:9852";

const api = axios.create({
  baseURL: modeURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const parsedToken = JSON.parse(token);
        config.headers.Authorization = `Bearer ${parsedToken}`;
      } catch (e) {
        console.warn('Token inválido no localStorage.');
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para lidar com erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token inválido ou expirado
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;